import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { NEWS_ITEM_FEATURE_KEY } from './keys';
import { newsItemReducer } from './reducers/news-item.reducer';
import { NewsItemEffects } from './effects/news-item.effects';

export function provideNewsItemStore(): EnvironmentProviders[] {
    return [provideState(NEWS_ITEM_FEATURE_KEY, newsItemReducer), provideEffects(NewsItemEffects)];
}
